var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_2125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7823 8.5C26.7823 13.196 23.105 17 18.5699 17C14.0347 17 10.3574 13.196 10.3574 8.5C10.3574 3.80403 14.029 0 18.5641 0C23.0993 0 26.7823 3.80403 26.7823 8.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6427 8.5C16.6427 13.196 12.9654 17 8.43022 17C3.89507 17 0.217773 13.196 0.217773 8.5C0.217773 3.80403 3.89507 0 8.43022 0C12.9654 0 16.6427 3.80403 16.6427 8.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4963 2.13672C15.2639 3.65213 16.3928 5.93562 16.3928 8.5C16.3928 11.0644 15.2631 13.3522 13.4963 14.8623C11.7302 13.3522 10.6018 11.0639 10.6018 8.5C10.6018 5.93582 11.7299 3.64678 13.4963 2.13672Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_2125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.d6a4c09e8efd0fee342a15fede44c88a.svg";
export { ForwardRef as ReactComponent };